<template>
  <div class="container-fluid">
    <purchases-invoice-form
      :loading="loading"
      :purchasesInvoiceData="purchasesInvoice"
      :formErrors="formErrors"
      @purchasesInvoiceSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import defaultTaxes from "@/constants/defaultTaxes";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultPurchasesInvoice from "../defaultPurchasesInvoice";
import PurchasesInvoiceForm from "../partials/PurchasesInvoiceForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    PurchasesInvoiceForm,
  },

  mixins: [alertLeave],

  data() {
    const purchasesInvoice = cloneDeep(defaultPurchasesInvoice);
    purchasesInvoice.taxes = cloneDeep(defaultTaxes);
    if (this.$currentUserIsLevelOrganization()) {
      purchasesInvoice.organization = {
        type: "organizations",
        id: this.$currentUserOrganizationId(),
      };
    }
    return {
      purchasesInvoice: purchasesInvoice,
      formErrors: null,
      loading: false,
    };
  },

  created() {},

  methods: {
    async handleSubmit(purchasesInvoice) {
      this.loading = true;
      const purchasesInvoiceData = cloneDeep(purchasesInvoice);
      try {
        await this.$store.dispatch(
          "purchasesInvoices/add",
          purchasesInvoiceData
        );
        this.$notify({
          type: "success",
          message: this.$t("PURCHASES_INVOICES.PURCHASES_INVOICE_ADDED"),
        });
        const purchasesInvoice = await this.$store.getters[
          "purchasesInvoices/purchasesInvoice"
        ];
        this.$emit("onViewPurchasesInvoice", purchasesInvoice, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
